import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';
import { UserSessionService } from '../services/user-session.service';
import {
  SidebarAppRole,
  normalizeSidebarRole,
} from '../../shared/ui/sidebar/sidebar-nav.util';

export const superAdminCanMatch: CanMatchFn = () => {
  const session = inject(UserSessionService);
  return normalizeSidebarRole(session.user()) === SidebarAppRole.SuperAdmin;
};

export const nonSuperAdminCanMatch: CanMatchFn = () => {
  const session = inject(UserSessionService);
  return normalizeSidebarRole(session.user()) !== SidebarAppRole.SuperAdmin;
};
